module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('example', {
    attrs: {
      "title": _vm.exs.ex1.title,
      "desc": _vm.exs.ex1.desc,
      "fiddlelink": _vm.exs.ex1.fiddlelink,
      "snippet": _vm.exs.ex1.snippet
    }
  }, [_c('circle-slider', {
    model: {
      value: (_vm.val1),
      callback: function($$v) {
        _vm.val1 = $$v
      },
      expression: "val1"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val1))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex2.title,
      "desc": _vm.exs.ex2.desc,
      "fiddlelink": _vm.exs.ex2.fiddlelink,
      "snippet": _vm.exs.ex2.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "min": 0,
      "max": 10000,
      "stepSize": 100
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val2))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex3.title,
      "desc": _vm.exs.ex3.desc,
      "fiddlelink": _vm.exs.ex3.fiddlelink,
      "snippet": _vm.exs.ex3.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "side": 150
    },
    model: {
      value: (_vm.val3),
      callback: function($$v) {
        _vm.val3 = $$v
      },
      expression: "val3"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "side": 50
    },
    model: {
      value: (_vm.val3),
      callback: function($$v) {
        _vm.val3 = $$v
      },
      expression: "val3"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val3))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex4.title,
      "desc": _vm.exs.ex4.desc,
      "fiddlelink": _vm.exs.ex4.fiddlelink,
      "snippet": _vm.exs.ex4.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "circle-width": 8,
      "progress-width": 12,
      "knob-radius": 10
    },
    model: {
      value: (_vm.val4),
      callback: function($$v) {
        _vm.val4 = $$v
      },
      expression: "val4"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-width": 10,
      "progress-width": 5,
      "knob-radius": 10
    },
    model: {
      value: (_vm.val4),
      callback: function($$v) {
        _vm.val4 = $$v
      },
      expression: "val4"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-width": 12,
      "progress-width": 3,
      "knob-radius": 4
    },
    model: {
      value: (_vm.val4),
      callback: function($$v) {
        _vm.val4 = $$v
      },
      expression: "val4"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val4))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex5.title,
      "desc": _vm.exs.ex5.desc,
      "fiddlelink": _vm.exs.ex5.fiddlelink,
      "snippet": _vm.exs.ex5.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "circle-width-rel": 30,
      "progress-width-rel": 15,
      "knob-radius-rel": 8
    },
    model: {
      value: (_vm.val5),
      callback: function($$v) {
        _vm.val5 = $$v
      },
      expression: "val5"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val5))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex6.title,
      "desc": _vm.exs.ex6.desc,
      "fiddlelink": _vm.exs.ex6.fiddlelink,
      "snippet": _vm.exs.ex6.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "circle-color": "#edeff0",
      "progress-color": "#cecece",
      "knob-color": "#a0a0ff"
    },
    model: {
      value: (_vm.val6),
      callback: function($$v) {
        _vm.val6 = $$v
      },
      expression: "val6"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-color": "#f00",
      "progress-color": "#0a0",
      "knob-color": "#0c0"
    },
    model: {
      value: (_vm.val6),
      callback: function($$v) {
        _vm.val6 = $$v
      },
      expression: "val6"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-color": "#cecece",
      "progress-color": "#00f",
      "knob-color": "#5555ff"
    },
    model: {
      value: (_vm.val6),
      callback: function($$v) {
        _vm.val6 = $$v
      },
      expression: "val6"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val6))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex7.title,
      "desc": _vm.exs.ex7.desc,
      "fiddlelink": _vm.exs.ex7.fiddlelink,
      "snippet": _vm.exs.ex7.snippet
    }
  }, [_c('circle-slider', {
    on: {
      "touchmove": function($event) {
        _vm.$refs.input.blur()
      }
    },
    model: {
      value: (_vm.val7),
      callback: function($$v) {
        _vm.val7 = $$v
      },
      expression: "val7"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.val7),
      expression: "val7",
      modifiers: {
        "number": true
      }
    }],
    ref: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.val7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val7 = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("vue-circle-slider demo")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Vue.js docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider",
      "target": "_blank"
    }
  }, [_vm._v("Plugin repo")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider-demo",
      "target": "_blank"
    }
  }, [_vm._v("This demo repo")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "nav-sidebar"
  }, [_c('h3', [_vm._v("Examples")]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Default"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Custom dimension"
    }
  }, [_vm._v("Custom dimension")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Custom side"
    }
  }, [_vm._v("Custom side")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Exact sizes"
    }
  }, [_vm._v("Exact sizes")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Relative sizes"
    }
  }, [_vm._v("Relative sizes")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Colors"
    }
  }, [_vm._v("Colors")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Two-way binding"
    }
  }, [_vm._v("Two-way binding")])]), _vm._v(" "), _c('h3', [_vm._v("CDN")]), _vm._v(" "), _c('p', [_vm._v("https://unpkg.com/vue-circle-slider@1.0.0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row footer"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v("vue-circle-slider")]), _vm._v(" "), _c('div', {}, [_c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider/subscription",
      "data-size": "large",
      "data-show-count": "true",
      "aria-label": "Watch devstark-com/vue-circle-slider on GitHub"
    }
  }, [_vm._v("Watch")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider",
      "data-size": "large",
      "data-show-count": "true",
      "aria-label": "Star devstark-com/vue-circle-slider on GitHub"
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider/archive/master.zip",
      "data-size": "large",
      "aria-label": "Download devstark-com/vue-circle-slider on GitHub"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com",
      "data-size": "large",
      "data-show-count": "true",
      "aria-label": "Follow @devstark-com on GitHub"
    }
  }, [_vm._v("Follow")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b1052fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 15
// module chunks = 0